import { h, inject, computed } from 'vue'

const shared = {
  color: String,
  striped: Boolean,
  animated: Boolean,
  precision: { type: Number, default: 0 },
  showPercentage: Boolean,
  showValue: Boolean,
  value: { type: Number, default: 0 },
  max: { type: Number, default: 100 }
}
const PROGRESS = Symbol('coreui-progress')

export const CProgressBar = {
  name: 'CProgressBar',
  // undefined defaults so we can tell which props were passed explicitly (Vue 2 used propsData)
  props: Object.keys(shared).reduce((o, k) => { o[k] = { type: shared[k].type || shared[k], default: undefined }; return o }, {}),
  setup (props, { slots }) {
    const parent = inject(PROGRESS, { props: {} })
    const p = computed(() => {
      const out = {}
      Object.keys(shared).forEach((k) => {
        const own = props[k]
        const fromParent = parent.props[k]
        const def = shared[k].default !== undefined ? shared[k].default : (shared[k] === Boolean ? false : undefined)
        out[k] = own !== undefined ? own : fromParent !== undefined ? fromParent : def
      })
      return out
    })
    return () => {
      const v = p.value
      const prec = Math.pow(10, v.precision)
      const progressValue = Math.round((100 * prec * v.value) / v.max) / prec
      const computedValue = Number(v.value).toFixed(v.precision)
      const text = v.showPercentage ? progressValue + '%' : v.showValue ? computedValue : undefined
      return h('div', {
        class: ['progress-bar', {
          [`bg-${v.color}`]: v.color,
          'progress-bar-striped': v.striped || v.animated,
          'progress-bar-animated': v.animated
        }],
        style: { width: `${(100 * (v.value / v.max))}%` },
        role: 'progressbar',
        'aria-valuemin': '0',
        'aria-valuemax': String(v.max),
        'aria-valuenow': computedValue
      }, slots.default ? slots.default() : text)
    }
  }
}

export const CProgress = {
  name: 'CProgress',
  props: { ...shared, height: String, size: String },
  provide () {
    const progress = {}
    Object.defineProperty(progress, 'props', { get: () => this.$props })
    return { [PROGRESS]: progress }
  },
  render () {
    return h('div', {
      class: ['progress', this.size && `progress-${this.size}`],
      style: { height: this.height }
    }, this.$slots.default ? this.$slots.default() : h(CProgressBar, { value: this.value }))
  }
}
